import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router';

import A from '../common/A';
import DevelopChannelSelectbox from '../../components/common/DevelopChannelSelectbox';

import { PROP, TYPE, URL } from '../../constant';
import { useAlert, useAppOcrOnOff, useAsideState, useLearningHistory, useUserInfo } from '../../hooks';
import useAmplitude from '../../hooks/useAmplitude';

function AsideV2() {
  const location = useLocation();
  const history = useHistory();
  const [Alert] = useAlert();
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const { handleOcr } = useAppOcrOnOff();
  const { learningHistoryInfo, onLearninStartBtn } = useLearningHistory();
  const { aSideState, setAsideState } = useAsideState();

  const [menuFlag, setMenuFlag] = useState(false);

  const closeMenu = useCallback(() => {
    setAsideState({menu : false});
    
  }, [aSideState])

  const moveGuide = useCallback(() => {
    setAsideState({ tab: 'course' });
    closeMenu();

    if(info.entryType === TYPE.CHANNEL.GLOBAL01) {
      onLearninStartBtn({type :'push'});
    } else {
      history.push({
        pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION
      });
    }
    
  }, [history]);

  const handlePage = useCallback((e, pathname) => {
    if (!pathname) return;
    let tab = '';
    let state = null;
    const { emailCertYn, isPaymentCountry, subScriptionPurchsYn, countryCd } = info;

    e.stopPropagation();
    closeMenu();
    switch (pathname) {
      case "/":
        tab = 'home';
        break;
      case URL.INTRODUCTION:
        tab = 'intro';
        break;
      case URL.TOPIC_LEARNING:
        tab = 'topic';
        pathname = URL.TOPIC_LEARNING;
        break;
      case URL.COURSE_LEARNING.LIST:
        let isShowPayment = isPaymentCountry;
        if(isShowPayment && !subScriptionPurchsYn) {
          if(countryCd === TYPE.COUNTRY_CODE.KOREA) {
            pathname = URL.PAYMENT.SUBSCRIBE;
          } else {
            pathname = URL.PAYMENT.SUBSCRIBE_NEW;
          }
        } else {
          if (learningHistoryInfo.isCompleteAIDiagnosis === 'N') {
            Alert(
              t("LC_01_02_lp.msg001"),
              moveGuide()
            )
            return;
          } else {
            setAsideState({ tab: 'course' });
            if (learningHistoryInfo.isCheckAIDiagnosisResult === 'Y') {
              pathname = URL.COURSE_LEARNING.LIST;
            } else {
              pathname = URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT;
            }
          }
        }

        break;
      case URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA:
      case URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION:
        if (learningHistoryInfo.isCompleteAIDiagnosis === 'Y') {
          pathname = URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT;
        }
        break;
      case URL.ACCOUNT.APP_ID_SIGN:
        if (emailCertYn === 'Y') {
          pathname = URL.ACCOUNT.APP_ID_SIGN_SUCCESS;
        }
        break;
      case URL.OCR.I:
        handleOcr();
        return;
      case URL.COURSE_LEARNING.LEARNING_NOTE:
        sessionStorage.removeItem('state');
        // 글러벌일 때 진단테스트 결과 없을 시 학습노트 주제학습 텝으로
        if (info.channelCode === TYPE.CHANNEL.GLOBAL01) {
          if (learningHistoryInfo.isCompleteAIDiagnosis === 'N') {
            state = 'theme';
          }
        }
        break;
      default:
        break;
    }
    setAsideState({ tab });
    history.push({
      pathname,
      state
    });

  }, [history, aSideState]);

  const handleLearner = useCallback(() => {
    const { learner, userId, userEmail } = info;
    
    if (learner && learner.length > 1) {
      closeMenu();
      history.push({
        pathname: URL.ACCOUNT.LEARNER_CHOICE,
        state: {
          email: userEmail,
          sbsceMbrId: userId,
          learner
        }
      });
    }
  }, [info]);

  const handleCloseMenu = useCallback(() => {
    closeMenu();
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: '메인메뉴 닫기' });
  }, [aSideState])

  useEffect(() => {
    setMenuFlag(aSideState.menu);
  }, [aSideState.menu]);


  if (!menuFlag) return <></>;

  return (
    <div className="lp-wrap">
      <div className={clsx(
        "lp-container gnb-menu gm",
        info.className,
      )}>
        <button
          className="btn-close-gnbmenu"
          onClick={handleCloseMenu}
        >메뉴 닫기</button>
        {
          (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') && (
            <DevelopChannelSelectbox />
          )
        }
        {
          (info?.entryType === TYPE.ENTRY_TYPE.GM_APP || info?.entryType === TYPE.ENTRY_TYPE.GLOBAL01) && (
            <div className="gnb-loginedBox">
              <div className="cont">
                <button
                  className="btn-chg-mypic"
                  onClick={handleLearner}
                >
                  {
                    info?.entryType === TYPE.ENTRY_TYPE.GLOBAL01 
                      ? <img src={`${process.env.PUBLIC_URL}/static/images/common/img_profilecha_th_01.svg`} alt="" />
                      : <img src={`${process.env.PUBLIC_URL}/${info.iconImage}`} alt="" />
                  }
                </button>
                <div className="gnb-myname">
                  <p className="js_name">{info?.learnerName}</p>
                  {/* {info?.entryType === TYPE.ENTRY_TYPE.GLOBAL01  && <button className="change">학습자 변경</button>} */}
                </div>
                
                {
                  (info?.entryType === TYPE.ENTRY_TYPE.GM_APP && (info?.learner && info?.learner.length > 1)) && (
                    <button
                      className="change"
                      onClick={handleLearner}
                    >
                      <img src={`${ process.env.PUBLIC_URL }/static/images/icon/ic_change.svg`} alt="" />
                    </button>
                  )
                }
              </div>
            </div>
          )
        }
        <>
          <div
            className={clsx({
              "gnb-list": true,
              "no_upper": (info.entryType === TYPE.ENTRY_TYPE.GM || info.entryType === TYPE.ENTRY_TYPE.WJTB)
            })}
          >
            <ul>
              {
                PROP.ASIDE_MEMU[info.entryType].MAIN.map((item, index) => (
                  <li key={index}>
                    <A
                      className={location.pathname.indexOf(item.path) > -1  ? 'here' : ''}
                      onClick={(e) => handlePage(e, item.path)}
                    >
                      {item?.localeCode ? t(`${item.localeCode}`) : item.title}
                    </A>
                  </li>
                ))
              }
            </ul>
          </div>
          {
            PROP.ASIDE_MEMU[info.entryType].SUB.length > 0 && (
              <div className="gnb-list small">
                <ul>
                  {
                    PROP.ASIDE_MEMU[info.entryType].SUB.map((item, index) => (
                      <li key={index}>
                        <A
                          onClick={(e) => handlePage(e, item.path)}
                        >
                          {item?.localeCode ? t(`${item.localeCode}`) : item.title}
                          {/* {item.title} */}
                        </A>
                      </li>
                    ))
                  }
                </ul>
              </div>
            )
          }
        </>
        {
          info?.entryType !== TYPE.ENTRY_TYPE.GLOBAL01 && <div className="cs">고객센터&nbsp;&nbsp;1577-1500</div>
        }
        
      </div>
    </div>
  );
}

export default AsideV2